import { OnInit, Component, Input, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ModuleType } from "@enums/ModuleType";
import { PeriodicNotificationModel } from "@app/mailmessages/models/periodicNotificationModel";
import { PeriodicNotificationService } from "@app/mailmessages/service/periodic-notification.service";
import { IncidentPeriodicNotificationService } from "@app/incident/services/incident-periodicnotification.service";

@Component({
    selector: "uc-periodic-notification-overview",
    templateUrl: "./periodic-notification-overview.component.html",
    styleUrls: ["./periodic-notification-overview.component.scss"],
    standalone: false
})
export class PeriodicNotificationOverviewComponent implements OnInit {
    private _tabService = inject(TabService);
    private _pnService = inject(PeriodicNotificationService);
    private _incidentService = inject(IncidentPeriodicNotificationService);
    pages = inject(Pages);

    @Input() module: ModuleType;

    config: GenericListConfig;

    ngOnInit() {
        if (this.module === ModuleType.Incidents) {
            this._incidentService.getIncidentNotifications().subscribe((data) => {
                for (let i = 0; i < data.length; i++) {
                    data[i].moduleType = ModuleType.Incidents;
                }
                this.setupConfig(data);
            });
        } else {
            this._pnService.getNotifications(this.module).subscribe((data) => {
                this.setupConfig(data);
            });
        }
    }

    setupConfig(data: PeriodicNotificationModel[]) {
        this.config = <GenericListConfig>{
            name: "Periodic Notifications",
            data: data,
            idProp: "id",

            allowAdd: true,
            allowEdit: true,
            allowDelete: false,

            fields: [
                {
                    fieldName: "name",
                    prettyName: "Name",
                    fieldType: GenericListFieldType.Text,
                    isReadonly: true,
                },
                {
                    fieldName: "subject",
                    prettyName: "Subject",
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: "active",
                    prettyName: "Send Active",
                    fieldType: GenericListFieldType.CheckBox,
                },
            ],
            addOverride: () => {
                const config = {
                    module: this.module,
                };
                this._tabService.generateTab(
                    this.pages.PeriodicDetail,
                    0,
                    "New periodic notification",
                    config
                );
            },
            editOverride: (row: PeriodicNotificationModel) => {
                const config = {
                    module: this.module,
                };
                this._tabService.generateTab(this.pages.PeriodicDetail, row.id, row.name, config);
            },
        };
    }
}
